import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'Benefits', href: '#benefits' },
    { label: 'Reviews', href: '#reviews' },
    { label: 'FAQ', href: '#faq' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-36 md:h-72 flex items-center justify-between">
        <a href="#" className="flex items-center">
          <img
            src="https://storage.readdy-site.link/project_files/1b4b5470-43ee-4e4c-a03f-80bf782ac886/295ea2cc-8770-43e6-ae89-4a5f4095a2e1_PAWZLY-7.png?v=947d967eac3d6db96af148317019d39e"
            alt="Pawzly Logo"
            className="h-32 md:h-72 w-auto object-contain transition-all duration-300"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-stone-700 hover:text-[#8A9B85]' : 'text-white/90 hover:text-white'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#product"
            className="bg-[#C4956A] hover:bg-[#b5845a] text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            Shop Now — $18
          </a>
        </div>

        <button
          className="md:hidden flex items-center justify-center w-9 h-9 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl ${scrolled ? 'text-stone-800' : 'text-white'}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-stone-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-stone-700 text-sm font-medium cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#product"
            onClick={() => setMenuOpen(false)}
            className="bg-[#C4956A] text-white text-sm font-semibold px-5 py-2.5 rounded-full text-center cursor-pointer whitespace-nowrap"
          >
            Shop Now — $18
          </a>
        </div>
      )}
    </header>
  );
}
